import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicineTablett: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medicine-tablett, pill"><path d="M11.9986 4.49959L4.49861 11.9996C2.42755 14.0707 2.42755 17.4285 4.49861 19.4996C6.56968 21.5707 9.92755 21.5707 11.9986 19.4996L19.4986 11.9996C21.5697 9.92852 21.5697 6.57066 19.4986 4.49959C17.4275 2.42852 14.0697 2.42852 11.9986 4.49959Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.5 8.5L15.5 15.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMedicineTablett;
